import React from 'react';
import PropTypes from 'prop-types';
import MuiDivider from '@material-ui/core/Divider';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { tokens } from '@facet-wealth/design';
import classNames from 'classnames';

const useStyles = buildUseStyles('Divider', (theme) => ({
  root: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  colorAttention: {
    background: tokens.color_sunset_500,
  },
  colorWhite: {
    background: tokens.color_white_100,
    opacity: 0.3,
  },
}));

const Divider = ({
  variant, light, component, color,
}) => {
  const classes = useStyles();

  return (
    <MuiDivider
      variant={variant}
      light={light}
      component={component}
      className={classNames(classes.root, { [classes.colorAttention]: color === 'attention' }, { [classes.colorWhite]: color === 'white' })}
    />
  );
};

Divider.defaultProps = {
  variant: 'fullWidth',
  component: 'ul',
  light: false,
  color: 'default',
};

Divider.propTypes = {
  variant: PropTypes.string,
  light: PropTypes.bool,
  component: PropTypes.string,
  color: PropTypes.oneOf(['default', 'attention', 'white']),
};

export default Divider;
